(() => {
  let pending, sequence = 0, opener;
  const rootFor = element => element.closest('[data-collection-section]');
  function updatePrices(scope = document) {
    const params = new URLSearchParams(location.search);
    scope.querySelectorAll('[data-price-min]').forEach(button => {
      const active = params.has('filter.v.price.gte') && Number(button.dataset.priceMin) === Number(params.get('filter.v.price.gte')) && Number(button.dataset.priceMax) === Number(params.get('filter.v.price.lte') || 0);
      button.classList.toggle('active', active); button.setAttribute('aria-pressed', String(active));
    });
  }
  function drawer(root, open, restore = true) {
    root.querySelector('.collection-filters').open = open;
    document.body.classList.toggle('collection-drawer-open', open);
    root.querySelectorAll('[data-open-collection-filter], .collection-filters>summary').forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open) root.querySelector('[data-close-collection-filter]:not(.collection-filter-backdrop)').focus();
    else if (restore && opener?.isConnected) opener.focus();
  }
  function formURL(form) {
    const url = new URL(form.action);
    for (const [key, value] of new FormData(form)) if (value !== '') url.searchParams.append(key, value);
    return url;
  }
  async function render(root, url, push = true) {
    pending?.abort(); pending = new AbortController(); const request = ++sequence;
    const controller = pending, timeout = setTimeout(() => controller.abort(), 15000);
    const status = root.querySelector('[data-collection-status]');
    root.setAttribute('aria-busy', 'true'); status.textContent = 'Updating products…';
    const sectionURL = new URL(url); sectionURL.searchParams.set('section_id', root.dataset.collectionSection);
    try {
      const response = await fetch(sectionURL, {signal:controller.signal});
      if (!response.ok) throw new Error('Collection unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = html.querySelector('[data-collection-section]');
      const selectors = ['.collection-filter-form', '.catalog-grid', '.catalog-pagination'];
      if (!fresh || selectors.some(selector => !fresh.querySelector(selector))) throw new Error('Incomplete collection');
      if (request !== sequence) return;
      const open = root.querySelector('.collection-filters').open;
      const focused = root.contains(document.activeElement) ? document.activeElement : null;
      const focusName = focused?.name, focusValue = focused?.value;
      selectors.forEach(selector => root.querySelector(selector).replaceWith(fresh.querySelector(selector)));
      if (push) history.pushState({}, '', url);
      if (opener && !opener.isConnected) opener = root.querySelector('.collection-filters>summary');
      updatePrices(root); drawer(root, open, false);
      if (focusName) {
        const target = [...root.querySelectorAll('input, select, button')].find(element => element.name === focusName && (element.type !== 'checkbox' || element.value === focusValue));
        target?.focus();
      }
      status.textContent = `${root.querySelectorAll('.catalog-grid .commerce-card').length} products shown.`;
    } catch (error) {
      if (request === sequence) location.assign(url.toString());
    } finally {
      clearTimeout(timeout);
      if (request === sequence) root.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const root = rootFor(event.target); if (!root) return;
    const filter = event.target.closest('[data-open-collection-filter], .collection-filters>summary');
    if (filter) { event.preventDefault(); opener = filter; root.querySelector('.collection-sort').classList.remove('is-open'); drawer(root, !root.querySelector('.collection-filters').open); return; }
    if (event.target.closest('[data-close-collection-filter]')) { drawer(root, false); return; }
    const sort = event.target.closest('[data-open-collection-sort]');
    if (sort) { drawer(root, false, false); const panel = root.querySelector('.collection-sort'); const open = panel.classList.toggle('is-open'); sort.setAttribute('aria-expanded', String(open)); if (open) panel.querySelector('select').focus(); return; }
    const range = event.target.closest('[data-price-min]');
    if (range) {
      const url = formURL(root.querySelector('form')); url.searchParams.set('filter.v.price.gte', range.dataset.priceMin);
      if (Number(range.dataset.priceMax) > 0) url.searchParams.set('filter.v.price.lte', range.dataset.priceMax); else url.searchParams.delete('filter.v.price.lte');
      render(root, url); return;
    }
    const link = event.target.closest('.filter-chip, .collection-filter-panel a, .catalog-pagination a');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault(); render(root, new URL(link.href));
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('.collection-filter-form')) return;
    event.preventDefault(); render(rootFor(event.target), formURL(event.target));
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('.collection-filter-panel input, .collection-sort select')) return;
    render(rootFor(event.target), formURL(event.target.form));
  });
  document.addEventListener('keydown', event => {
    const root = document.querySelector('.collection-filters[open]')?.closest('[data-collection-section]');
    if (event.key === 'Escape') {
      if (root) drawer(root, false);
      document.querySelectorAll('.collection-sort.is-open').forEach(panel => panel.classList.remove('is-open'));
      document.querySelectorAll('[data-open-collection-sort]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    }
    if (event.key === 'Tab' && root) {
      const items = [...root.querySelector('.collection-filter-panel').querySelectorAll('button, a[href], input, select')].filter(element => !element.disabled && element.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });
  window.addEventListener('popstate', () => { const root = document.querySelector('[data-collection-section]'); if (root) render(root, new URL(location.href), false); });
  document.addEventListener('shopify:section:load', event => { document.body.classList.remove('collection-drawer-open'); updatePrices(event.target); });
  updatePrices();
})();
